/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps, Theme } from '@mui/material';

export const headerContainerSX =
	(visible: boolean): SxProps<Theme> =>
	(_: Theme) => ({
		backgroundColor: 'background.paper',
		borderRadius: 0,
		transform: visible ? 'translateY(0)' : 'translateY(-66px)',
		transition: 'transform 0.3s ease-in-out',
		top: 0,
		overflow: 'visible',
		position: 'sticky',
		zIndex: 9000,
		boxShadow: visible ? '0px 2px 4px rgba(0, 0, 0, 0.1)' : 0,
	});
